// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import cardWidgetMulti from './js/widgets/cardWidgetMulti.js';
// import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetEmail from './js/widgets/cardWidgetEmail.js';
import seoWidget from './js/widgets/seoWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';
//import footerLogos from './js/widgets/footerLogos.js';


// Custom Theme Scripts
import './js/localjs.js';
import './js/SiteInfoBanner.js';
// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    // cardWidget();   
    cardWidgetMulti();
    swiperWidget();
    hotButtons();
    // multiScheduleFeature();
    cardWidgetEmail();
    seoWidget();
    cssSponsors();

  });
}

$(document).ready(function() {
  // put footer widgets here
  //footerLogos();
});